export enum FahrkostenStatus {
  ENTWURF= "ENTWURF" , // nur Antragsteller
  EINGEREICHT="EINGEREICHT" , // nur schule + schulträger
  GEDRUCKT = "GEDRUCKT" , // nur schule + schulträger
  IN_BEARBEITUNG_SCHULTRAEGER = "IN_BEARBEITUNG_SCHULTRAEGER" , // nur schultraeger
  ABGESCHLOSSEN = "ABGESCHLOSSEN" , // keiner
  BESTAETIGT_SCHULE = "BESTAETIGT_SCHULE" , // nur schulträger
  IN_BEARBEITUNG_SCHULE = "IN_BEARBEITUNG_SCHULE" // nur schule
}
